import { useMemo } from 'react';
import { useRoles } from './authorization.hook';

/** Returns `true` if User has one of given `requiredRoles`.
 *
 * E.g. User must have `role1` OR `role2`
 * ```
 * roles = ['role1', 'role2']
 * ```
 */

type UserRole = 'Admin' | 'Support' | 'Purchase' | 'Basic';

export function useHasRole() {
  const permissions = useRoles();
  const userRole = useMemo(() => {
    if (permissions?.includes('ResellerAdmin')) return 'Admin';
    else if (permissions?.includes('PlaceOrders')) return 'Purchase';
    else if (permissions?.includes('ViewOrderStatus')) return 'Support';
    else return 'Basic';
  }, [permissions]);

  return (requiredRoles: UserRole[]) => {
    return requiredRoles.includes(userRole);
  };
}
